import { useEffect, useRef, useState } from "react";

/**
 * Ensures a passed in value remains true for a minimum duration.
 */
export const useMinimumDuration = (value: boolean, minDurationMs: number): boolean => {
  const [heldValue, setHeldValue] = useState(value);
  const startedRef = useRef<number | null>(value ? Date.now() : null);
  const timeoutIdRef = useRef<number | null>(null);

  useEffect(() => {
    if (value) {
      startedRef.current = Date.now();
      setHeldValue(true);

      if (timeoutIdRef.current) {
        window.clearTimeout(timeoutIdRef.current);
      }

      return;
    }

    if (startedRef.current === null) {
      setHeldValue(false);

      return;
    }

    const remainingMs = Math.max(0, minDurationMs - (Date.now() - startedRef.current));
    timeoutIdRef.current = window.setTimeout(() => {
      startedRef.current = null;
      setHeldValue(false);
    }, remainingMs);

    const timeoutId = timeoutIdRef.current;

    return () => window.clearTimeout(timeoutId);
  }, [value, minDurationMs]);

  return heldValue;
};
